type callback = (events: eventData) => void;
type callbackEvents = (events: CustomEvent[]) => void;

export type eventData = { [event: string]: Array<CustomEvent> };
export const throttleListener = (event: string, timeout: number, callback: callbackEvents): void => {
  let d: CustomEvent[] = [];
  let i: NodeJS.Timeout;

  document.addEventListener(event, data => {
    d.push(data as CustomEvent);
    clearTimeout(i);
    i = setTimeout(() => {
      callback(d);
      d = [];
    }, timeout);
  });
};

export const listen = (events: Array<string>, callback: callback): void => {
  const eventsData: eventData = {};

  events.map(event => {
    if (!eventsData[event]) {
      eventsData[event] = [];
    }
  });

  events.map(event => {
    throttleListener(event, 50, data => {
      eventsData[event] = eventsData[event].concat(data);

      if (events.every(event => eventsData[event].length > 0)) {
        callback(eventsData);
      }
    });
  });
};
